/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import auth from '@client/components/auth';
import PillSelect, {
  SquarePill,
} from '@client/components/collections/PillSelect';
import { MenuItem, Select, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';
import { CollectionProgram } from './collections.types';
import { Program } from '@playbook-technologies/common-enums';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { inputHolder, label as fieldLabel } from '../legacyForms.css';

type AdminSectionProps = {
  program: CollectionProgram;
  influencerId: number;
  save: () => Promise<boolean>;
  onInAppPurchaseChange: (inAppPurchase: 'allow' | 'hide') => void;
  onIsLockedChange: (isLocked: boolean) => void;
};

export const SettingsSection = (props: AdminSectionProps) => {
  const { program, onInAppPurchaseChange, onIsLockedChange } = props;
  const [inAppPurchase, setInAppPurchase] = useState(program.inAppPurchase);
  const [isLocked, setIsLocked] = useState(program.isLocked);

  const handleIsLockedChange = (event: string[]) => {
    const isLocked = Boolean(event[0] === 'true');
    setIsLocked(isLocked);
    onIsLockedChange(isLocked);
  };

  useEffect(() => {
    setIsLocked(program.isLocked);
    setInAppPurchase(program.inAppPurchase);
  }, [program]);

  const isOTP = props.program.accessType === Program.AccessType.Exclusive.value;

  return (
    <div className="admin-section">
      {!isOTP ? null : (
        <div className="inline-flex">
          <div className={inputHolder}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                marginBottom: '10px',
                gap: '8px',
              }}
            >
              <label className={fieldLabel} style={{ marginBottom: 0 }}>
                In App purchase
              </label>
              <Tooltip
                title={<InAppPurchaseTooltipText />}
                placement="right-start"
                componentsProps={{
                  tooltip: {
                    open: true,
                    sx: {
                      bgcolor: 'black',
                      color: 'white',
                      fontSize: '14px',
                      fontFamily: 'inherit',
                      borderRadius: '10px',
                      width: 'max-content',
                      p: '16px 8px',
                    },
                  },
                }}
              >
                <FontAwesomeIcon icon={faInfoCircle} />
              </Tooltip>
            </div>
            <Select
              value={inAppPurchase}
              disabled={!!program.archivedAt}
              onChange={(event) => {
                const nextValue =
                  event.target.value === 'allow' ? 'allow' : 'hide';
                onInAppPurchaseChange(nextValue);
                setInAppPurchase(nextValue);
              }}
            >
              <MenuItem value="allow">Allow</MenuItem>
              <MenuItem value="hide">Hide</MenuItem>
            </Select>
          </div>
        </div>
      )}

      {(auth.isAdministrator() || auth.isModerator()) && (
        <div className="adminOnlySection">
          <div className="mt-3">
            <PillSelect
              label="Allow Edits"
              disabled={false}
              Pill={SquarePill}
              values={[String(isLocked)]}
              options={[
                { name: 'Lock', value: 'true' },
                { name: 'Allow', value: 'false' },
              ]}
              onChange={handleIsLockedChange}
              gap={0}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const InAppPurchaseTooltipText = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '15px',
      padding: '0 20px',
      alignItems: 'flex-start',
      justifyContent: 'center',
      height: '100%',
    }}
  >
    <div style={{ textAlign: 'left' }}>
      <u>
        <strong>Hide</strong>
      </u>
      {` - Program is visible only by users with access to it. Won't be
   displayed on the list on default.`}
    </div>
    <div style={{ textAlign: 'left' }}>
      <u>
        <strong>Allow</strong>
      </u>{' '}
      - Program is always displayed on the program list. Users with no access
      will encounter a paywall
    </div>
  </div>
);
